export const GET_IDP_LIST = 'GET_IDP_LIST'
export const FINISH_TASK = 'FINISH_TASK'